import { Routes, Route, Navigate } from 'react-router-dom';

import PlaceFares from '@/Pages/fares/place-fares/PlaceFares';
import FranchiseFormContainer from '@/Pages/fares/franchise-form/FranchiseFormContainer';
import FranchiseList from '@/Pages/fares/franchise-list/FranchiseList';
import PlaceFaresFormContainer from '@/Pages/fares/place-fares-form-container/PlaceFaresFormContainer';

function Fares() {
  return (
    <Routes>
      <Route path="/" element={<FranchiseList />} />

      <Route path="/municipio/criar" element={<FranchiseFormContainer />} />

      <Route
        path="/estabelecimento/criar"
        element={<PlaceFaresFormContainer />}
      />

      <Route
        path="/municipio/editar/:franchiseId"
        element={<FranchiseFormContainer />}
      />

      <Route
        path="/estabelecimento/editar/:placeId"
        element={<PlaceFaresFormContainer />}
      />

      <Route path="/:cityId" element={<PlaceFares />} />

      <Route path="*" element={<Navigate to="/not-found" replace />} />
    </Routes>
  );
}

export default Fares;
